// extracted by mini-css-extract-plugin
export default {"backdrop":"error_backdrop__1Mt-0","modal":"error_modal__rlgPY","slide-down":"error_slide-down__abkdl","content":"error_content__4x1lK","button":"error_button__M8AmH"};